<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title
      :title="{ name: '付款管理', path: '/system/payment/all' }"
    ></Title>

    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-input
              v-model="qparam.projectName"
              placeholder="项目名称"
            ></el-input>
          </el-col>

          <el-col :span="5">
            <el-input
                v-model="qparam.paymentCompanyName"
                placeholder="收款方"
            ></el-input>
          </el-col>

          <el-col :span="9">
            <el-date-picker
              style=""
              v-model="applyTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col
            :span="5"
            style="float: right; margin-left: 10px; margin-top: 10px"
          >
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置
            </el-button>
            <el-button icon="el-icon-search" type="primary" @click="search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="projectName" label="项目名称">
          </el-table-column>
          <el-table-column prop="paymentCompanyName" label="收款方">
          </el-table-column>
          <el-table-column width="100px" prop="paymentMoney" label="收款金额">
          </el-table-column>
          <el-table-column width="160px" prop="applyTime" label="申请时间">
          </el-table-column>


          <el-table-column width="260px" label="操作">
            <template v-slot="scope">
              <el-button size="mini" @click="handleDetail(scope.row)">查看</el-button>
              <el-button size="mini" type="primary" @click="handlePrint(scope.row)">打印</el-button>
              <el-button size="mini" type="primary" @click="handleCustomPrint(scope.row)">自定义打印</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>
      <!--项目付款详情-->
      <el-dialog
      title="项目付款信息"
      :visible.sync="paymentDialogVisible"
      width="1200px"
      top="6vh">
      <ProjectPaymentDetailsDialog
       :key="uuid"
       :applyId="applyId"
       :applyServiceId="applyServiceId"
       :applyType="applyType"
       :role="1 || 4"
       @open-contract="handleOpenContract"/>
    </el-dialog>
    <!--合同详情-->
    <el-dialog title="合同信息" :visible.sync="contractDialogVisible" top="6vh" width="1200px" @close="handleContractClose">
      <ContractDialog :contract-id="contractId"/>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "@/components/Title";
import {requestAllPaymentApply, requestPrintPayment, requestPrintReimburse} from "@/api"
import {uuid,AesDecrypt} from "@/util";
import ProjectPaymentDetailsDialog from "@/components/item/common/ProjectPaymentDetailsDialog.vue";
import ContractDialog from "@/components/item/common/ContractDialog.vue";

export default {
  name: "AllPaymentApply",
  components: {ContractDialog, Title, ProjectPaymentDetailsDialog},
  
  data() {
    return {
      uuid: "",
      hasAllRole: false,
      applyId: "",
      applyServiceId: "",
      applyType: "",
      paymentDialogVisible: false,
      contractDialogVisible: false,
      contractId: null,
      applyTime: [],
      tableData: [],
      totalElements: 0,
      qparam: {
          current: 1,
          size: 10,
          paymentCompanyName: "",
          projectName: "",
          startTime: "",
          endTime: "",
      },
      user: {}
    }
  },
  computed: {
    ...mapState(["flowData"]),
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
    this.initTableData()
  },

  methods: {
    async initTableData() {
      this.qparam.startTime = this.applyTime[0]
      this.qparam.endTime = this.applyTime[1]
      const hasAllRole = this.user.roles.includes(1) || this.user.roles.includes(4)
      if (hasAllRole) {
        const res = await requestAllPaymentApply(this.qparam);
        if (res.code === 200) {
          this.totalElements = res.total
          this.tableData = res.rows
          let data = this.tableData
          this.tableData = data
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData()
    },
    resetQparam() {
      this.applyTime = []
      this.qparam.paymentCompanyName = ""
      this.qparam.projectName = ""
      this.initTableData()
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData()
    },
    async search() {
      this.qparam.current = 1
      this.qparam.size = 10
      await this.initTableData()
    },
    handleOpenContract(contractId) {
      // 打开合同详情，先关闭付款详情
      this.contractId = contractId
      this.paymentDialogVisible = false
      this.$nextTick(() => {
        this.contractDialogVisible = true
      })
    },
    handleContractClose() {
      // 关闭合同详情后回到付款详情
      this.contractDialogVisible = false
      this.$nextTick(() => {
        this.paymentDialogVisible = true
      })
    },
    handleDetail(row) {
      this.paymentDialogVisible = true
      this.applyId = row.applyId
      this.applyServiceId = row.applyServiceId
      this.applyType = row.applyType
      this.uuid = uuid()
    },
    handlePrint(row){
      requestPrintPayment({ paymentId: row.applyServiceId,type:1,applyId:row.applyId }).then(
          (res) => {
            if (res.code === 200) {
              window.location.href = res.object;
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          }
      );
    },
    handleCustomPrint(row){
      requestPrintPayment({ paymentId: row.applyServiceId,type:2 }).then(
          (res) => {
            if (res.code === 200) {
              window.location.href = res.object;
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          }
      );
    }
  }
}
</script>

<style>
.paybackInfo {
  display: flex;
}
.paybackInfo-btn {
  margin-left: 12px;
  cursor: pointer;
  color: #409eff;
}

.low {
  /*  color: #f56c6c;*/
  color: red;
}
.middle {
  color: #e6a23c;
}
.height {
  /*  color: #5cb87a;*/
  color: green;
}
</style>

<style scoped>
.tags-container {
  display: flex;
  flex-wrap: wrap;
}

.tag-item {
  margin-right: 8px; /* tag 之间的间距 */
  margin-bottom: 8px; /* 换行时的间距 */
}

.delivery-type-column .el-tag {
  display: inline-block; /* 确保 tag 作为行内块元素显示 */
}
</style>
